import {Component, Inject, Input, OnInit} from '@angular/core';
import {
    APIPoliciesComponent,
    LeftpanelComponent,
    LoaderWithProgressComponent,
    OAuth2ToggleConfirmationComponent,
    ScheduleJobDialogComponent, ViewRawComponent
} from '../leftpanel/leftpanel.component';
import {ConfService} from '../conf.service';
import {Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {error} from 'selenium-webdriver';
import {ListenerService} from '../listener.service';
import {SchedulerListenerService} from '../scheduler-listener.service';
import cronstrue from 'cronstrue';
import {KongService} from '../kong.service';
import {environment} from '../../environments/environment';
import {ToggleJobStatusComponent} from '../manage-scheduled-jobs/manage-scheduled-jobs.component';
import {AccountInfoService} from '../user/account-info.service';

@Component({
    selector: 'app-manage-trigger',
    templateUrl: './manage-trigger.component.html',
    styleUrls: ['./manage-trigger.component.scss']
})
export class ManageTriggerComponent implements OnInit {

    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    @Input() pkey = localStorage.getItem('partnerKey');
    @Input() apikey = localStorage.getItem('apikey');

    columns = ['Trigger Name', 'Description', 'API\'s', 'Status', 'Created', ''];
    jobMappingToSort = ['', 'job_name', '', '', '', '', ''];

    constructor(public platform: LeftpanelComponent,
                public schedulerListenerInstance: SchedulerListenerService,
                public listener: ListenerService,
                public accountInfoService: AccountInfoService,
                public confpost: ConfService,
                public router: Router,
                public dialog: MatDialog) {
        listener.jobScheduled.subscribe(status => {
            if (status) {
                this.refreshScheduledJobs();
            }
        });
    }

    scheduledJobs: any;
    schedulerLogs: any;
    componentLoading = true;
    triggerHistory: any = [];

    ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.getScheduledJobs();
    }

    toggleExecutor(ev, a, trigger_name) {
        this.triggerHistory = [];
        if (ev.target.className === 'fa fa-chevron-down') {
            const historyPayload = {
                'partner': this.partner,
                'account': this.account,
                'significance': 'compose',
                'intent': 'triggerLogs',
                'data': {
                    'trigger_name': trigger_name
                }
            };
            this.confpost.postCoreApi('triggersLog', environment.coreAPI.triggersLog.version, historyPayload).subscribe(data => {
                const res: any = data;
                this.triggerHistory = res.items.data;
            }, err => {
                this.platform.handleErrorGracefully(err, 'Error while retrieving trigger history.');
            });
        }
        $('.' + a).slideToggle();
        $(ev.target).toggleClass('fa-chevron-up fa-chevron-down');

    }

    getTime(val) {
        if (typeof val === 'number') {
            return this.platform.timeConverter(val);
        } else {
            return val;
        }
    }

    getTrigger(trigger) {
        let triggerString = '';
        if (trigger) {
            if (trigger['type'] === 'date') {
                triggerString = 'Once at ';
                const startDateTime = trigger['configurations']['run_date'].split(' ');
                triggerString = triggerString + startDateTime[1] + ' on ' + startDateTime[0];
                return triggerString;
            } else if (trigger['type'] === 'interval') {
                const startDateTime = trigger['configurations']['start_date'].split(' ');
                const endDateTime = trigger['configurations']['end_date'].split(' ');
                if (trigger['configurations'].hasOwnProperty('seconds')) {
                    triggerString = triggerString + 'Every second from ' + startDateTime[0] + ' at ' + startDateTime[1] + ' till ' + endDateTime[0] + ' at ' + endDateTime[1];
                } else if (trigger['configurations'].hasOwnProperty('minutes')) {
                    triggerString = triggerString + 'Every minute from ' + startDateTime[0] + ' at ' + startDateTime[1] + ' till ' + endDateTime[0] + ' at ' + endDateTime[1];
                } else if (trigger['configurations'].hasOwnProperty('hours')) {
                    triggerString = triggerString + 'Every hour from ' + startDateTime[0] + ' at ' + startDateTime[1] + ' till ' + endDateTime[0] + ' at ' + endDateTime[1];
                } else if (trigger['configurations'].hasOwnProperty('days')) {
                    triggerString = triggerString + 'Every day from ' + startDateTime[0] + ' at ' + startDateTime[1] + ' till ' + endDateTime[0] + ' at ' + endDateTime[1];
                } else if (trigger['configurations'].hasOwnProperty('weeks')) {
                    triggerString = triggerString + 'Every week from ' + startDateTime[0] + ' at ' + startDateTime[1] + ' till ' + endDateTime[0] + ' at ' + endDateTime[1];
                }
                return triggerString;
            } else if (trigger['type'] === 'cron') {
                return cronstrue.toString(trigger['cron_expression'], {verbose: true});
            }
        }
    }

    async getScheduledJobs() {
        this.componentLoading = true;
        // if (this.platform.scheduledJobs && this.platform.scheduledJobs !== null && this.platform.scheduledJobs !== undefined && this.platform.scheduledJobs !== '') {
        //   this.scheduledJobs = this.platform.scheduledJobs;
        //   this.schedulerLogs = this.platform.schedulerLogs;
        //   this.componentLoading = false;
        // } else {
        //   await Promise.resolve(this.platform.getScheduledJobs()).then(response => {
        //     this.scheduledJobs = this.platform.scheduledJobs;
        //     this.schedulerLogs = this.platform.schedulerLogs;
        //     this.componentLoading = false;
        //   }, error => {
        //     this.router.navigateByUrl('/controlplane');
        //   });
        // }
        const payload = {
            'partner': this.partner,
            'account': this.account,
            'significance': 'compose',
            'intent': 'triggers'
        };
        this.confpost.postCoreApi('triggersLog', environment.coreAPI.triggersLog.version, payload).subscribe(data => {
            const res: any = data;
            this.scheduledJobs = res.items.data;

            this.componentLoading = false;
        }, err => {
            this.platform.handleErrorGracefully(err, 'Error while retrieving trigger.');
            this.componentLoading = false;
            this.router.navigateByUrl('/controlplane');
        });

    }

    deleteTrigger(trigger) {
        if (confirm('This action is irreversible. Do you still want to delete ' + trigger.trigger_name + ' ?')) {
            const payload = {
                partner: this.partner,
                account: this.account,
                significance: 'eliminate',
                intent: 'triggers',
                data: {trigger_name: trigger.trigger_name}
            };

            this.confpost.postCoreApi(environment.coreAPI.trigger.name, environment.coreAPI.trigger.version, payload).subscribe(data => {
                let res: any;
                res = data;
                this.platform.openSnackBar(trigger.trigger_name + ' deleted successfully.', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.getScheduledJobs();
            }, err => {
                this.platform.handleErrorGracefully(err, 'Error while deleting trigger. Please try again later');
            });
        }
    }

    refreshScheduledJobs() {
        this.componentLoading = true;
        Promise.resolve(this.platform.getScheduledJobs()).then(response => {
            this.scheduledJobs = this.platform.scheduledJobs;
            this.schedulerLogs = this.platform.schedulerLogs;
            this.componentLoading = false;
        }, error => {
            this.router.navigateByUrl('/controlplane');
        });
    }

    viewRaw(obj) {
        const rawDialog = this.dialog.open(ViewRawComponent, {
            width: '60%',
            data: {
                title: 'Response Data',
                JSON: obj,
                type: 'Trigger'
            }
        });
    }

    getHistoryCount(job) {
        if (this.schedulerLogs) {
            const logs = this.schedulerLogs.filter((log) => log['details']['job_id'] === job['job_meta']['id']);
            job['history_logs'] = logs;
            return logs.length;
        }
    }

    getMessage(responseObject) {
        if (responseObject['body'] && responseObject['body'][0] && responseObject['body'][0].hasOwnProperty('body')) {
            return responseObject['body'][0]['body'];
        } else {
            return '';
        }
    }

    statusToggle(event, job) {
        // const confirmPrompt = this.dialog.open(ToggleJobStatusComponent, {
        //   width: '60%',
        //   disableClose: true,
        //   data: {
        //     jobName: job['job_name'],
        //     status: job['status'],
        //   }
        // });
        //
        // confirmPrompt.afterClosed().subscribe(response => {
        //   if (response) {
        //     if (response === 'pause') {
        //       this.pauseJob(job);
        //     } else if (response === 'resume') {
        //       this.resumeJob(job);
        //     } else {
        //       event.source.checked = !event.source.checked;
        //     }
        //   } else {
        //     event.source.checked = !event.source.checked;
        //   }
        // });
    }

    createJob() {
        const configuration = {};
        const dialogRef = this.dialog.open(ScheduleJobDialogComponent, {
            minWidth: '26vw',
            height: 'auto',
            data: {
                mode: 'edit-trigger',
                name: '',
                version: '',
                configuration: configuration,
                startDateActualFormat: '',
                endDateActualFormat: '',
                jobName: '',
                jobDescription: '',
                wholeData: {}
            }
        });

        dialogRef.afterClosed().subscribe(response => {
            this.getScheduledJobs();
        });
    }

    editJob(job) {
        const configuration = {};
        const dialogRef = this.dialog.open(ScheduleJobDialogComponent, {
            minWidth: '26vw',
            height: 'auto',
            data: {
                mode: 'edit-trigger',
                name: job['executors'][0]['source_model']['executor_name'],
                version: job['executors'][0]['source_model']['executor_version'],
                configuration: configuration,
                startDateActualFormat: '',
                endDateActualFormat: '',
                jobName: job['trigger_name'],
                jobDescription: job['description'],
                wholeData: job
            }
        });

        dialogRef.afterClosed().subscribe(response => {
            this.getScheduledJobs();
        });
    }

    rescheduleJob(job) {
        const configuration = {
            type: job['trigger']['type'],
            configurations: job['trigger']['configurations'],
        };
        if (job['trigger']['type'] === 'cron') {
            configuration['cron_expression'] = job['trigger']['cron_expression'];
        }
        const dialogRef = this.dialog.open(ScheduleJobDialogComponent, {
            width: 'auto',
            height: 'auto',
            data: {
                mode: 'reschedule',
                name: job['executors'][0]['executor_name'],
                version: job['executors'][0]['executor_version'],
                configuration: configuration,
                startDateActualFormat: job['trigger']['start_date_actual_format'],
                endDateActualFormat: job['trigger']['end_date_actual_format'],
                jobName: job['job_name'],
                jobDescription: job['description'],
                wholeData: job
            }
        });

        dialogRef.afterClosed().subscribe(response => {
            this.refreshScheduledJobs();
        });
    }

    resumeJob(job) {
        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'scheduler_resume_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.schedulerListenerInstance.schedulerListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.confpost.resumeJob(this.partner, this.account, this.pkey, this.apikey, job['job_meta']['id']).subscribe(data => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'scheduler_resume_success', 'INFO', data.status, data.statusText, '', {
                partner: this.partner,
                account: this.account,
                id: job['job_meta']['id']
            }, data, this.router.url)).then(response => {
                const payloadToSend = {
                    actions: response
                };
                this.schedulerListenerInstance.schedulerListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            loaderDialog.close();
            this.platform.openSnackBar('Job resumed successfully.', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.refreshScheduledJobs();
        }, error1 => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'scheduler_resume_failed', 'ERROR', error1.status, error1.statusText, this.platform.returnErrorMessage(error1), {
                partner: this.partner,
                account: this.account,
                id: job['job_meta']['id']
            }, error1, this.router.url)).then(response => {
                const payloadToSend = {
                    actions: response
                };
                this.schedulerListenerInstance.schedulerListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            this.platform.handleErrorGracefully(error1, 'Error while resuming the job. Please try again after sometime');
            loaderDialog.close();
        });
    }

    pauseJob(job) {
        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'scheduler_pause_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.schedulerListenerInstance.schedulerListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.confpost.pauseJob(this.partner, this.account, this.pkey, this.apikey, job['job_meta']['id']).subscribe(data => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'scheduler_pause_success', 'INFO', data.status, data.statusText, '', {
                partner: this.partner,
                account: this.account,
                id: job['job_meta']['id']
            }, data, this.router.url)).then(response => {
                const payloadToSend = {
                    actions: response
                };
                this.schedulerListenerInstance.schedulerListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            loaderDialog.close();
            this.platform.openSnackBar('Job paused successfully.', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.refreshScheduledJobs();
        }, error1 => {
            Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'scheduler_pause_failed', 'ERROR', error1.status, error1.statusText, this.platform.returnErrorMessage(error1), {
                partner: this.partner,
                account: this.account,
                id: job['job_meta']['id']
            }, error1, this.router.url)).then(response => {
                const payloadToSend = {
                    actions: response
                };
                this.schedulerListenerInstance.schedulerListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            this.platform.handleErrorGracefully(error1, 'Error while pausing the job. Please try again after sometime');
            loaderDialog.close();
        });
    }

    deleteJob(job) {
        if (confirm('The action is irreversible. Do you still want to delete the job?')) {
            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'scheduler_delete_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
                const payloadToSend = {
                    actions: response
                };
                this.schedulerListenerInstance.schedulerListener.emit({
                    type: 'audit',
                    id: localStorage.getItem('IdOfSession'),
                    payload: payloadToSend
                });
            });
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            this.confpost.deleteJob(this.partner, this.account, this.pkey, this.apikey, job['job_meta']['id']).subscribe(data => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'scheduler_delete_success', 'INFO', data.status, data.statusText, '', {
                    partner: this.partner,
                    account: this.account,
                    id: job['job_meta']['id']
                }, data, this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.schedulerListenerInstance.schedulerListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                loaderDialog.close();
                this.platform.openSnackBar('Job deleted successfully.', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.refreshScheduledJobs();
            }, error1 => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'scheduler_delete_failed', 'ERROR', error1.status, error1.statusText, this.platform.returnErrorMessage(error1), {
                    partner: this.partner,
                    account: this.account,
                    id: job['job_meta']['id']
                }, error1, this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.schedulerListenerInstance.schedulerListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                this.platform.handleErrorGracefully(error1, 'Error while deleting the job. Please try again after sometime');
                loaderDialog.close();
            });
        }
    }

    createPaddingRight() {
        document.getElementById('view:scheduler').style.paddingRight = '400px';
    }

    removePaddingRight() {
        document.getElementById('view:scheduler').style.paddingRight = '0px';
    }
}
